import { render } from "./Landingpage.vue?vue&type=template&id=78426abe&scoped=true"
import script from "./Landingpage.vue?vue&type=script&lang=js"
export * from "./Landingpage.vue?vue&type=script&lang=js"

import "./Landingpage.vue?vue&type=style&index=0&id=78426abe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78426abe"

export default script